import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'report-batch-history',
  data: function () {
    var today = new Date
    return {
      searchId: this.$route.params.id,
      searchIdType: this.$route.params.type,
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      sendDate: null,
      searchCallbackFlag: false,
      watchScroll: null,
      // ソート
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        't_batch_send.to_type':     {'state': false, 'order': false},
        't_batch_send.send_type':   {'state': false, 'order': false},
        't_batch_send.send_status': {'state': false, 'order': false},
        't_batch_send.send_time':   {'state': true , 'order': false}, // desc
      },
      sortStateInit: {},
      tmpRbh: null,
      viewMoreFlg: {}
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    if (utils.isPresent(this) && '$store' in this) {
      if (this.$store.getters.reportBatchHistoriesSearchParams !== null) {
        this.$store.getters.reportBatchHistoriesSearchParams['pageYOffset'] = window.pageYOffset // スクロール位置保存
        this.$store.getters.reportBatchHistoriesSearchParams['scrollHeight'] = utils.getScrollHeight() // スクロール高さ保存
      }
      if (this.watchScroll !== null) {
        this.watchScroll.disconnect()
        this.watchScroll = null
      }
    }
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    next()
  },
  created () {
    var readMore = false
    var ssYear = window.sessionStorage.getItem('rbhis-year')
    var ssMonth = window.sessionStorage.getItem('rbhis-month')
    var ssSendDate = window.sessionStorage.getItem('rbhis-sendDate')
    var ssSortKey = window.sessionStorage.getItem('rbhis-sortKey')
    var ssSortStateOrder = window.sessionStorage.getItem('rbhis-sortStateOrder')
    if (!!ssYear) {
      this.year = ssYear
    }
    if (!!ssMonth) {
      this.month = ssMonth
    }
    if (!!ssSendDate) {
      this.sendDate = ssSendDate
    }
    if (!!ssSortKey) {
      var key = ssSortKey
      this.sortKey = key
      if (ssSortStateOrder != null) {
        if (ssSortStateOrder === "true") {
          this.sortStateOrder = true
        } else {
          this.sortStateOrder = false
        }
      } else {
        this.sortStateOrder = !this.sortState[key].order
      }
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = this.sortStateOrder
    }

    // ソート初期化用保存
    for (var k in this.sortState) {
      this.sortStateInit[k] = {}
      this.sortStateInit[k].state = this.sortState[k].state
      this.sortStateInit[k].order = this.sortState[k].order
    }

    // ソート初期化用保存
    for (var k in this.sortState) {
      this.sortStateInit[k] = {}
      this.sortStateInit[k].state = this.sortState[k].state
      this.sortStateInit[k].order = this.sortState[k].order
    }

    if (this.$store.getters.canManage) {
      // 店舗ID
      this.shopId = this.$store.getters.currentShopId
    }

    this.search(readMore)

    // 最下部スクロールイベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  computed: {
    orderedBatchReports () {
      return this.reportBatchHistories
    },
    reportBatchHistories () {
      return this.$store.getters.reportBatchHistories
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    nextPage () {
      return this.$store.getters.reportBatchHistoriesNextPage
    },
    currentPage () {
      return this.$store.getters.reportBatchHistoriesCurrentPage
    },
    totalCount () {
      return this.$store.getters.reportBatchHistoriesTotalCount
    },
    years () {
      var today = new Date
      var years = []
      for (var y = 2015; y <= today.getFullYear(); y++ ) {
        years.push({'id': y, 'text': y + this.$t('ymd.year')})
      }
      return years
    },
    months () {
      var months = []
      for (var m = 1; m <= 12; m++ ) {
        months.push({'id': m, 'text': m + this.$t('ymd.month')});
      }
      return months
    }
  },
  methods: {
    /** 戻る */
    goPrev: function () {
      if (this.$route.params.type === 'facility') {
        this.$router.push({path: '/facilities', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.$route.params.type === 'facility_person') {
        this.$router.push({path: '/facility_persons', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.$route.params.type === 'clinic') {
        this.$router.push({path: '/clinics', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.$route.params.type === 'care_office') {
        this.$router.push({path: '/care_offices', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      }
    },
    goReportHistory: function () {
      this.$router.push({path: '/reports/history/'+ this.searchIdType + '/' + this.searchId, query: {type: this.$router.currentRoute.query.type}})
    },
    changeYm: function (readMore) {
      this.sendDate = null
      this.search(readMore)
    },
    /** 報告書送信履歴検索 */
    search: function (readMore) {
      var url = null
      var clear = true
      var page = null
      var loadparams = 'true'
      var self = this

      if (readMore === 'sort') {
        // ソート読み込み
        clear       = false
        loadparams  = 'block'
      } else if (readMore === 'keepload') {
        // 再読込
        clear = false
        loadparams = 'block'
        this.searchCallbackFlag = true

        // スクロール位置
        var pageYOffset = this.$store.getters.reportBatchHistoriesSearchParams['pageYOffset']
        var scrollHeight = this.$store.getters.reportBatchHistoriesSearchParams['scrollHeight']
        this.$store.getters.reportBatchHistoriesSearchParams['pageYOffset'] = null
        this.$store.getters.reportBatchHistoriesSearchParams['scrollHeight'] = null
        this.watchScroll = utils.setScrollHeight(scrollHeight, pageYOffset)
      } else if (readMore) {
        // 次ページ
        url = this.$store.getters.reportBatchHistoriesNextPage
        clear = false
        loadparams = 'block'
      } else {
        // 通常
        this.searchCallbackFlag = false
      }

      var callback = function () {
        self.searchCallbackFlag = true
      }

      var search_send_date = ''
      if (utils.isPresent(this.sendDate) && utils.isWareki(this.$t, this.sendDate)) {
        search_send_date = utils.wareki2Seireki(this.$t, this.sendDate, 'ymd')
        this.year = Number(search_send_date.substring(0,4))
        this.month = Number(search_send_date.substring(4,6))
      }
      var data = {
        'shop_id':           this.shopId,
        'search_id':         this.searchId,
        'search_id_type':    this.searchIdType,
        'year':              this.year,
        'month':             this.month,
        'search_send_date':  search_send_date,
        'ggsSearchSendDate': this.sendDate,
        'order':             this.orderByString()
        // ページング用
        // 'page': page
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }

      window.sessionStorage.setItem('rbhis-year', this.year)
      window.sessionStorage.setItem('rbhis-month', this.month)
      if (!!this.sendDate) {
        window.sessionStorage.setItem('rbhis-sendDate', this.sendDate)
      } else {
        window.sessionStorage.removeItem('rbhis-sendDate')
      }
      if (!!this.sortKey) {
        window.sessionStorage.setItem("rbhis-sortKey", this.sortKey)
      } else {
        window.sessionStorage.removeItem("rbhis-sortKey")
      }
      if (this.sortStateOrder !== "") {
        window.sessionStorage.setItem("rbhis-sortStateOrder", this.sortStateOrder)
      } else {
        window.sessionStorage.removeItem("rbhis-sortStateOrder")
      }

      this.$store.dispatch('REPORT_BATCH_HISTORY_SEARCH', {url: url, clear: clear, data: data, loadparams: loadparams, callback: callback})
      .then((res) => {this.searchCallback(res)})
    },
    searchCallback: function (params) {
      this.viewMoreFlg = {}
      for(var i = 0; params.meta['total-count'] > i; i++) {
        var data = params.data[i]
        if(data.attributes['report-count'] >= 4) {
          this.viewMoreFlg[data.id] = true
        }
      }
    },
    clearSearchParams: function () {
      // if (this.$store.getters.canManage && this.shopId === null) {
      //   this.shopId = this.$store.getters.currentShopId
      // }
      var today = new Date
      this.year =  today.getFullYear()
      this.month = today.getMonth() + 1
      this.sendDate = null

      this.$store.dispatch('REPORT_BATCH_HISTORY_CLEAR', 0)
    },
    /** ソート */
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order

      // 検索
      this.search('sort')
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          result.push(key + ' ' + asc_desc)
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('t_batch_send.send_time desc')
      }
      return result.join(' , ')
    },
    tmpSaveRbh: function(rbh) {
      this.tmpRbh = rbh
    },
    resendBatchHistory: function() {
      var tmpRbh = this.tmpRbh
      var callback = function () {
        tmpRbh.attributes['resend-flag'] = true;
        if (tmpRbh.attributes['send-type'] == 2) {
          tmpRbh.attributes['send-status'] = constant.report.send_status.sending;
        }
      }
      this.$store.dispatch('REPORT_BATCH_HISTORY_RESEND',{ data: { id: this.tmpRbh.id }, callback: callback })
      this.tmpRbh = null
    },
    cancelResend: function() {
      this.tmpRbh = null
      this.$store.dispatch('REPORT_BATCH_HISTORY_RESEND',{ data: { id: rbh.id }, callback: callback })
    },
    viewMoreContents: function(id) {
      this.viewMoreFlg[id] = false
      this.$forceUpdate()
    },
    viewMore: function (id) {
      var viewMoreFlg = this.viewMoreFlg[id]
      return viewMoreFlg
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/report-batch-history.js